<template>
  <div class="page-container">

    <el-card class="mt-4">
      <router-link to='/today/goals'>today</router-link> |
      <router-link to='/today/priorities'>priorities</router-link> |
      <router-link to='/goal/Hf_E07azTam5gPQ2zoJxdw/task/AKFcSWqTQCCdWZ5yDDajAQ'>XXX</router-link>

      <div>
        Ready method 1: {{$ready_commitments}}
      </div>

      <div>
        Ready method 2: {{commitments_ready}}
      </div>

      <!-- <VisualAnalysis /> -->
    </el-card>

    <div style="height: 500px; border: 1px solid blue; width: 50px; display: flex;">
      <CommitmentSessionHairline :sessions="[[10,20],[30,45],[90,95]]" />
    </div>

    <el-button class="m-4" @click="onTestGiphy">Push for random gif</el-button>

    <h4>Progressbar für Tasks:</h4>
    <ProgressBar
      :value1="50"
      :value2="75"
      type="line-double"
      :stroke-width="18"
      :text-inside="true"
      color1="#aa1816"
      color2="#17abe3"
      :width="400"
      :target="100"
      unit="min"
      :stepSize="1"></ProgressBar>
    <br />
    <ProgressBar
      :value1="50"
      :value2="52"
      type="line-double"
      :stroke-width="18"
      :text-inside="true"
      color1="#aa1816"
      color2="#17abe3"
      :width="400"
      :target="100"
      unit="min"
      :stepSize="5"></ProgressBar>
    <br />
    <ProgressBar
      :value1="50"
      :value2="100"
      type="line-double"
      :stroke-width="18"
      :text-inside="true"
      color1="#aa1816"
      color2="#17abe3"
      :width="400"
      :target="100"
      unit="min"
      :stepSize="15"></ProgressBar>
    <br />
    Sessions Today:

    <ProgressBar
      :value1="1"
      :value2="maxSessionsToday"
      type="line-double"
      :stroke-width="18"
      :text-inside="true"
      color1="#aa1816"
      color2="#17abe3"
      :width="400"
      :target="3"
      unit="sessions"
      :stepSize="1"
      :outerTextWidth="100"
      @newTarget="setNewTarget"
      :showError="showError"></ProgressBar>
    <br /><br />

    <h4>Timeslots Serialization Test (check log)</h4>
    <button @click="serializeTimeslots()">Serialize Timeslots</button>
    <br /><br />

    <!--
    <h4>Pexels API Integration:</h4>
    <el-input placeholder="Type here" v-model="pexelsSearchQuery">Eiffel Tower</el-input>
    <button @click="getPexelsImages('search')">Search for images</button>  (powered by Pexels)
    <br />
    <div style="height: 700px; width:100%" class="pexelsScrollbox" ref="pexelsScrollbox" v-if="pexelsSearchQuery !== ''">
      <div class="pexelsScrollbox-content"  @wheel="handleScrollPexels">
        <div v-if="pexelsData && pexelsPhotos">
          <ul :style="gridStyle" class="card-list">
            <li  v-for="(photo) in pexelsPhotos" :key="photo.id" class="card-item">
              <img v-lazy="photo.src.square" style="padding:5px; display: grid; width:100%" >
            </li>
          </ul>
          <button @click="getPexelsImages('url', pexelsData.prev_page)" v-if="pexelsData.prev_page">Prev page</button>
          <button @click="getPexelsImages('url', pexelsData.next_page)" v-if="pexelsData.next_page">Next page</button>
        </div>
      </div>
    </div>
    <br /><br />
  -->

    <!--
    <h1>SidebarTabs</h1>
    <el-card style="margin-top:1em;">
      <SidebarTabs preselected-tab-hash="ID3">
        <Tab id="ID1" name="Unused1">
          <div slot="label" slot-scope="slotProps" style="border: 1px solid green">
            Slot L1
            {{slotProps}}
          </div>
          Content 1
        </Tab>
        <Tab id="ID2" name="Unused2">
          <div slot="label"  style="border: 2px solid green">
            Slot L2
          </div>
          Content 2
        </Tab>
        <Tab id="ID3" name="No Slot">
          Content 3
        </Tab>
        <div slot="final">
          <el-button>Add item</el-button>
        </div>
      </SidebarTabs>
    </el-card>
    <br /><br />
    -->

    <!--
    <div class="page-header">
      <h1>Kanban Board</h1>
      <p class="lead">An example of a Kanban board, written in VueJS</p>
    </div>
    <KanbanMenuBar />
    <KanbanBacklog />
    <KanbanBoard />
    -->

    <!--
    <h1>PowerUserTaskList</h1>
    <PowerUserTaskList />
    -->

    <!--
    <div v-for="timeslot_collection in timeslot_collection_list"
      v-if="!timeslot_collection.deleted"
      :key="timeslot_collection.$id" >
      <span>* {{timeslot_collection.type}}</span>
      <span v-switch="timeslot_collection.type">
        <span v-case="'TSC'">TSC1th</span>
        <span v-case="'BLOCKER'">BLOCKER1b</span>
        <span v-case="'GOOGLE'">GOOGLE1</span>
        <span v-default>Default</span>
      </span>
    </div>
    -->

    <!--
    <h2>TimezoneTests</h2>
    <TimezoneTests />
    -->

    <!--
    <h2>v-switch</h2>
    <div v-switch="size">
      <h1 v-case="'large'">Large</h1>
      <h2 v-case="'medium'">Medium</h2>
      <h3 v-case="'small'">Small</h3>
    </div>
    -->

    <!--
    <full-calendar ref="calendar" :events="[]" :config="calendar_config"></full-calendar>
    <el-card>
      TODO: this component can not handle user timezone
      businessHours.start: <el-time-select v-model="calendar_config.businessHours.start" /><br>
      businessHours.end: <el-time-select v-model="calendar_config.businessHours.end" /><br>
      minTime: <el-time-select v-model="calendar_config.minTime" /><br>
      maxTime: <el-time-select v-model="calendar_config.maxTime" /><br>
      nowIndicator: <el-switch v-model="calendar_config.nowIndicator"></el-switch><br>
      defaultView:
      <el-select v-model="calendar_config.defaultView" placeholder="Select">
        <el-option label="agendaWeek" value="agendaWeek"></el-option>
        <el-option label="agenda" value="agenda"></el-option>
      </el-select><br>
      <div v-if="calendar_config.defaultView === 'agenda'">
        TODO: This should be replace with date-selector and timezone=null
        visibleRange.start: <el-date-picker type="date" v-model="calendar_config.visibleRange.start" /><br>
        visibleRange.end: <el-date-picker type="date" v-model="calendar_config.visibleRange.end" /><br>
      </div>
      firstDay: <el-input-number v-model="calendar_config.firstDay" :min="1" :max="7"></el-input-number><br>
      <el-button @click="save">save</el-button>
      <pre>{{calendar_config}}</pre>
    </el-card>
    -->

    <!--
    <h2>v-switch</h2>
    <div v-switch="size">
      <h1 v-case="'large'">Large</h1>
      <h2 v-case="'medium'">Medium</h2>
      <h3 v-case="'small'">Small</h3>
    </div>
    -->

    <!--
    <h4>Webworker in VUEX Test:</h4>
    Webworker status: <div v-if="webworkertest_worker_running">running</div> <div v-else>inactive</div>
    <button @click="webworkertest_worker1({ value: 'input value' })">Run Optimizer</button>
    {{ webworkertest_getter }}
    <el-progress :text-inside="true" :stroke-width="18" :percentage="progress"></el-progress>

    <br />
    <br />
    <h4>Session Efforts:</h4>
    <el-row >
      <el-col :span="7">
        <Sessions width="300px" height="500px" />
      </el-col>
    </el-row>
    <pre>
      {{ this.workerList }}
    </pre>
    -->

  </div>
</template>

<script>
import { mapReady } from '@/api/misc'
import { mapGetters, mapActions } from "vuex";
import $ from 'jquery'
import ProgressBar from "@/components/Elements/ProgressBar"
import CommitmentSessionHairline from '@/components/Experiments/CommitmentSessionHairline'
// import Sessions from "@/components/Sessions/Sessions"
// import PowerUserTaskList from '@/components/SessionPage/Tasks/PowerUserTaskList'
// import SidebarTabs from "@/components/Elements/SidebarTabs"
// import Tab from "@/components/Elements/SidebarTabElement"
// import SessionTaskList from '@/components/FocusPage/SessionTaskList'
// import TimezoneTests from './TimezoneTests'
// import MarkdownEditor from "./MarkdownEditor";
// import KanbanBoard from "@/components/Kanban/KanbanBoard"
// import KanbanMenuBar from '@/components/Kanban/MenuBar';
// import KanbanBacklog from '@/components/Kanban/Backlog';
import { vSwitch, vCase, vDefault } from 'v-switch-case'
import moment from '@/moment-gp'
//var LZUTF8 = require('lzutf8');
import LZUTF8 from 'lzutf8'
//import Worker from './file.worker.js';
//import Worker from '@/WebWorkers/worker.js';
// import { FullCalendar } from 'vue-full-calendar'
import GiphyMixin from "@/components/Mixins/Giphy"

export default {
  name: "ShareContainer",
  mixins: [ GiphyMixin ],
  data() {
    return {
      pexelsSearchQuery: '',
      pexelsData: {},
      pexelsPhotos: [],
      pexelsPage: '',
      maxSessionsToday: 3,
      showError: false,
      size: 'medium',
      calendar_config: {
        defaultView: 'agenda',
        visibleRange: {
          start: '2018-11-17',
          end: '2018-11-20'
        },
        columnHeader: true,
        firstDay: 1,
        editable: true,
        selectable: true,
        nowIndicator: true,
        minTime: "02:00:00",
        maxTime: "22:00:00",
        themeSystem: 'bootstrap4',
        header: false,
        now: Date.now(),
        businessHours: {
          dow: [ 1, 2, 3, 4, 5 ], // Monday - Friday
          start: '8:00',
          end: '18:00',
        },
      },
      data: [],
      busy: false,
      count: 0,
      TSCtest: {
      },
      workerList: [],
      loading: false
    }
  },
  computed: {
    // Method 1:
    ...mapReady('commitments'), // erstellt prop '$ready_*'

    // Method 2:
    commitments_ready() {
      return this.$api.get_ready('commitments')
    },
    gridStyle() {
      let numberOfColumns = 4
      return {
        gridTemplateColumns: `repeat(${numberOfColumns}, minmax(100px, 1fr))`
      }
    },
    ...mapGetters('webworkertest', [
      "webworkertest_getter",
      "webworkertest_worker_running"
    ]),
    progress() {
      //onsole.log(this.webworkertest_getter)
      return parseInt(this.webworkertest_getter)
    },
  },
  methods: {
    ...mapActions('webworkertest', [
      "webworkertest_worker1",
      "webworkertest_worker2"
    ]),
    webworkerstoreIncrease() {
      this.webworkertest_worker1({ value: 'input value' })
      this.webworkertest_worker2({ value: 'input value' })
    },
    save() {
      console.log("test");

      /* It has to be done this way! Don't save fullCalendar to a variable it
         will destroy the 'this' context of full Calendar */
      const calendarElement = $(this.$refs.calendar.$el);
      // calendarElement.fullCalendar('option', 'nowIndicator', false);

      const update_key_list = [
        'businessHours',
        'minTime',
        'maxTime',
        'nowIndicator', // - geht nicht
        'columnHeader',
        'firstDay',
      ]

      update_key_list.forEach(key => {
        console.log("=> option", key, '=>', this.calendar_config[key]);
        calendarElement.fullCalendar('option', key, this.calendar_config[key]);
      })

      calendarElement.fullCalendar('changeView',
        this.calendar_config['defaultView'], {
          start: this.calendar_config['visibleRange'].start,
          end: this.calendar_config['visibleRange'].end
        }
      );
    },

    notifyMe() {
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        // Let's check whether notification permissions have already been granted
        // If it's okay let's create a notification
        Notification("Hi there!");
        console.log('Notification')
      } else if (Notification.permission !== "denied") {
        // Otherwise, we need to ask the user for permission
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            Notification("Hi there!");
            console.log('Notification')
          }
        });
      }
      // At last, if the user has denied notifications, and you
      // want to be respectful there is no need to bother them any more.
    },
    actions(number) {
      console.log('action' + number)
      return [
        {
          message: 'func1',
          func: number => {
            let i = 0
            while ( i < 2500000000 ) {
              i += 1
              if (i % 100000000 === 0) {
                console.log(`Worker 2: ${`number`}` , i )
              }
            }
            return `Worker 2: ${`number`}` + ' done'
          }
        },
      ]
    },
    setNewTarget(value) {
      setTimeout(() => {
        if (value > 5) {
          this.showError = true;
        } else {
          this.showError = false;
        }
        this.maxSessionsToday = Math.min(value, 5)
        }, 1000)

    },

    getPexelsImages(source, url) {
      let pexelsQuery = ''
      if (source === 'search') {
        pexelsQuery = 'https://api.pexels.com/v1/search?query=' +
                  this.pexelsSearchQuery.replace(" ", "+") +
                  '&per_page=64&page=1'
      } else if  (source === 'url') {
        pexelsQuery = url
      }
      return new Promise((resolve, reject) => {

        let headers = new Headers({
          'Authorization': '563492ad6f9170000100000172ee330295c54306b9879279c876707a'
        });
        console.log('url', pexelsQuery)
        fetch(pexelsQuery, {

          method: 'get',
          headers: headers

        }).then((response) => {
          return response.json();

        }).then((data) => {
          this.pexelsData = data
          console.log('vorher:', this.pexelsPhotos)
          this.pexelsPhotos = this.pexelsPhotos.concat(data.photos)
          console.log('nachher:', this.pexelsPhotos)
          console.log("Got data from Pexels", data);

        }).catch(reject)

      });
    },
    handleScrollPexels (event) {
      console.log(this.$refs)
      let scrollboxElement = this.$refs.pexelsScrollbox
      console.log(scrollboxElement.scrollTop, scrollboxElement.scrollHeight)

      if (scrollboxElement.scrollTop > scrollboxElement.scrollHeight - scrollboxElement.offsetHeight - 500) {
        console.log('ok', this.pexelsData, this.pexelsData.next_page)
        if (this.pexelsData.next_page && this.pexelsPage !== this.pexelsData.next_page ) {
          this.pexelsPage = this.pexelsData.next_page
          this.getPexelsImages('url', this.pexelsData.next_page)
        }
      };
      this.lastScrollTop = scrollboxElement.scrollTop
    },
    serializeTimeslots() {
      var t0 = performance.now();

      let timeslots = []
      let nowTimestamp = moment().unix().toFixed(0)
      let nowTimestampRounded = (nowTimestamp - nowTimestamp % 60)
      let lastUntil = nowTimestampRounded
      for (let i = 0; i < 5000; i++ ) {
        if (i > 0) {
          lastUntil = timeslots[i - 1].until
        }
        let pause = (Math.random() * 200).toFixed(0)
        pause = (pause - pause % 5)
        let duration = (Math.random() * 240).toFixed(0)
        duration = (duration % 5)
        //console.log(pause, duration)
        timeslots.push ({
          from: lastUntil + pause * 60,
          until: lastUntil + pause * 60 + duration * 60
        });

      }
      //console.log('timeslots', timeslots)
      let TimeslotsSerialized = []
      let nrTimeslots = Object.keys(timeslots).length
      //console.log('nrTimeslots', nrTimeslots)

      if (nrTimeslots > 0) {
        TimeslotsSerialized.push (timeslots[0].from)
        TimeslotsSerialized.push((timeslots[0].until - timeslots[0].from - (timeslots[0].until - timeslots[0].from) % 60) / 60) // rounded to minutes
        for (let index = 1; index < nrTimeslots; index++ ) {
          TimeslotsSerialized.push(((timeslots[index].from - timeslots[index - 1].until) - (timeslots[index].from - timeslots[index - 1].until) % 60) / 60)
          TimeslotsSerialized.push(((timeslots[index].until - timeslots[index].from) - (timeslots[index].until - timeslots[index].from) % 60) / 60 )
        }
      }
      TimeslotsSerialized = JSON.stringify(TimeslotsSerialized)

      let TimeslotsSerializedCompressed = LZUTF8.compress(TimeslotsSerialized)

      //let sizeOriginal = Buffer.byteLength(JSON.stringify(timeslots), 'utf8') / 1024
      //let sizeCompressed = Buffer.byteLength(TimeslotsSerializedCompressed, 'utf8') / 1024
      //console.log('original size of object:', sizeOriginal, 'Kbytes');
      //console.log('TimeslotsSerialized compressed size:', sizeCompressed, 'Kbytes');
      //console.log('Compression:', ((1 - sizeCompressed / sizeOriginal) * 100).toFixed(2) + '%', 'Kbytes');

      let timeslotsDecompressed = LZUTF8.decompress(TimeslotsSerializedCompressed);
      //let sizeDecompressed = Buffer.byteLength(timeslotsDecompressed, 'utf8') / 1024
      //console.log('timeslots decompressed:', timeslotsDecompressed);

      //console.log('sizeDecompressed:',sizeDecompressed, 'Kbytes');
      //console.log('converted back to array:',JSON.parse(timeslotsDecompressed), 'Kbytes');
      let TimeslotsSerializedNew = JSON.parse(timeslotsDecompressed)

      // rebuild original timeslot object:
      let nrEntries = TimeslotsSerializedNew.length
      let timeslotsNew = []
      if (nrEntries > 0) {
        timeslotsNew.push( {
          from: TimeslotsSerializedNew[0],
          until: TimeslotsSerializedNew[0] + TimeslotsSerializedNew[1] * 60
        })

        lastUntil = timeslotsNew[0].until
        for (let i = 1; i < nrEntries / 2; i++) {
          timeslotsNew.push({
            from: timeslotsNew[i - 1].until + TimeslotsSerializedNew[i * 2] * 60,
            until: timeslotsNew[i - 1].until + TimeslotsSerializedNew[i * 2] * 60 + TimeslotsSerializedNew[i * 2 + 1] * 60
          })
        }
      }
      var t1 = performance.now();
      console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.")
      //console.log('timeslots converted back to original after serialization and compression:', timeslotsNew, Buffer.byteLength(JSON.stringify(timeslotsNew)) / 1024 + ' KBytes')
    },

    onTestGiphy() {
      this.getRandomGif().then(gif_url => {
        this.$notify.success({
          type: 'success',
          title: "Random gif",
          dangerouslyUseHTMLString: true,
          duration: 6500,
          message: `<img src="${gif_url}" />`
        })
      })
    }
  },
  components: {
    // PowerUserTaskList,
    // FullCalendar,
    // TimezoneTests,
    // KanbanBoard,
    // KanbanMenuBar,
    // KanbanBacklog,
    // SessionTaskList
    ProgressBar,
    // Sessions
    CommitmentSessionHairline,
  },
  directives: {
    'switch': vSwitch,
    'case': vCase,
    'default': vDefault
  }
};
</script>

<style>
.card-list {
  display: grid;
  grid-gap: 0.1em;
}
.card-item {
  background-color: #ffffff;
  padding: 0;
}
ul {
  list-style-type: none;
}

.pexelsScrollbox {
  overflow-y: auto;
  visibility: hidden;
  font-size: 8pt
}

.pexelsScrollbox-content,
.pexelsScrollbox:hover,
.pexelsScrollbox:focus {
  visibility: visible;
}
</style>
